<template>
  <el-dialog title="设置提醒" :destroy-on-close="true" :visible.sync="disableDialog" width="414px">
    <el-form :model="queryParams">
      <el-row>
        <el-col :span="16">
          <el-form-item label="设置提醒：" label-width="85px">
            <el-date-picker
              v-model="time"
              style="width:100%;"
              type="datetime"
              format='yyyy-MM-dd HH:mm'
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期时间"
              :picker-options="$store.state.Sell.time"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-center">
      <el-button @click="onSubmit" type="primary">提交</el-button>
      <el-button @click="disableDialog = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      disableDialog: false,
      queryParams: {},
      time: '',
      index: ''
    }
  },
  methods: {
    onInitial (val) {
      this.time = ''
      this.index = val
      this.disableDialog = true
    },
    // 提交
    onSubmit () {
      if (this.index === 'all') {
        this.$emit('onSetTimeAll', this.time)
      } else {
        this.$emit('onSetTime', this.time, this.index)
      }
      this.disableDialog = false
    }
  }
}
</script>
